import { CompleteAddress } from '@dreryk/address-common-api';
import {
   CurrentInvoiceProviderAccountInfoQuery,
   InvoiceAccountCreateCommand,
} from '@dreryk/egabinet-invoice-frontend-api';

import { refetchCqrsQuery, useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarNegativeEvent } from '@dreryk/react-components';
import { Choice } from '@dreryk/watermelon';

import { invoiceCreateAccountModalTranslationKeys } from '../../translations';

import { InvoiceCreateAccountFormBean } from './form/InvoiceCreateAccountForm.types';

type UseInvoiceAccountCreateCommandOptions = {
   onSuccess: VoidFunction;
};

export const useInvoiceAccountCreateCommand = (
   options: UseInvoiceAccountCreateCommandOptions
): UseCqrsCommandResult<void, InvoiceCreateAccountFormBean> =>
   useCqrsCommand<void, InvoiceCreateAccountFormBean>(
      (parameters) => {
         const command = new InvoiceAccountCreateCommand();
         const completeAddress = CompleteAddress.builder()
            .withTown(parameters.town!)
            .withPostcode(parameters.postcode!)
            .withStreet(parameters.street)
            .withBuilding(parameters.building!)
            .withFlat(parameters.flat)
            .build();

         command.address = completeAddress;
         command.bankAccountNumber = parameters.bankAccountNumber;
         command.bankName = parameters.bankName;
         command.bdoNumber = Choice.withUseDefaultIfNull(parameters.bdoNumber);
         command.companyName = parameters.companyName;
         command.email = parameters.email;
         command.password = parameters.password;
         command.taxIdentifier = parameters.taxIdentifier;

         return command;
      },
      {
         onSuccess: () => {
            refetchCqrsQuery(CurrentInvoiceProviderAccountInfoQuery);
            options.onSuccess();
         },
         onUnexpectedError: () => {
            dispatchSnackbarNegativeEvent(invoiceCreateAccountModalTranslationKeys.creatingAccountFailed);
         },
      }
   );
